import { useState } from "react";
import { IconButton, Link, Tooltip, Typography } from "@mui/joy";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "../i18n";
import OpenInNewRounded from "@mui/icons-material/OpenInNewRounded";
import { Link as RouterLink } from "react-router-dom";

export interface SkuRefProps {
  uniqueId: string;
  teamSlug: string;
  openInNewWindow?: boolean;
  copy?: boolean;
}

export default function SkuRef({
  uniqueId,
  teamSlug,
  openInNewWindow,
  copy,
}: SkuRefProps) {
  const t = useTranslation();
  const [copied, setCopied] = useState<string | null>(null);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(uniqueId);
    setCopied(uniqueId);
    setTimeout(() => setCopied(null), 200);
  };
  const short =
    uniqueId.slice(0, 3) +
    ".." +
    uniqueId.slice(uniqueId.length - 3, uniqueId.length);
  return (
    <Typography
      sx={{ display: "unset" }}
      fontSize={12}
      startDecorator={
        copy && (
          <Tooltip arrow title={<Typography>{t("Copy Ref #")}</Typography>}>
            <IconButton
              size="sm"
              variant={copied === uniqueId ? "solid" : "plain"}
              color={copied === uniqueId ? "success" : "neutral"}
              onClick={handleCopyToClipboard}
            >
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        )
      }
    >
      <Link
        sx={{ fontFamily: "monospace" }}
        component={RouterLink}
        to={`/${teamSlug}/sku/${uniqueId}`}
        target={openInNewWindow ? "_blank" : ""}
        endDecorator={openInNewWindow ? <OpenInNewRounded /> : null}
      >
        {short.toUpperCase()}
      </Link>
    </Typography>
  );
}
